/**
 * One group covers both halves of selling: issuing a mentoring offer and
 * starting a Stripe payment. Whoever can hand a client an offer must also be
 * able to charge for it, so splitting the two would only produce a person who
 * gets halfway through the sale.
 *
 * Levels are a ladder ordered by declaration - `seedPermissionsForRoles` grants
 * every level up to the one assigned, so `NONE` must stay first.
 */
export const PAYMENT__PERMISSIONS = {
  PAYMENTS: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie płatnościami',
      NONE: {
        dbName: 'PAYMENT__PAYMENTS__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do ofert mentoringu i do uruchamiania płatności.'
      },
      ENABLED: {
        dbName: 'PAYMENT__PAYMENTS__MANAGE__ENABLED',
        name: 'Sprzedaż mentoringu i płatności',
        description: [
          'Możesz:',
          '- wystawiać oferty mentoringu i przekazywać kupującym link do płatności',
          '- generować linki do płatności Stripe, w tym po bezpłatnej konsultacji'
        ].join('\n')
      }
    }
  }
} as const
